import {useQuery, gql} from '@apollo/client'

const groupDetails = gql`
  query grouplistdetails($clientId: Numeric) {
    groupList(clientId: $clientId) {
      CLIENT_ID
      CLIENT_NAME
      GROUPList {
        GROUP_ID
        GROUP_NAME
        TOTAL_ACTIVE_USERS
        TOTAL_ARCHIVE_USERS
        IS_COMPLETED
      }
    }
  }
`

export function useGetGroupDetails(clientId, skip = false) {
  const {
    data: group,
    loading: loadingGroups,
    error: errorGroups,
    refetch: refetchGroups
  } = useQuery(groupDetails, {
    context: {clientName: 'adminPanel'},
    variables: {clientId},
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    skip
  })
  return {group, loadingGroups, errorGroups, refetchGroups}
}
